import { useContext } from 'react'
import styled, { css } from 'styled-components'
import { TentativeScoringQuestionContext } from '@app.feature/exam/gsat2024-2/context/TentativeScoringQuestionContext'

const answerNumberMap = ['①', '②', '③', '④', '⑤']

const TentativeScoringTableBody = () => {
  const { examGradingQuestions } = useContext(TentativeScoringQuestionContext)

  return (
    <StyledWrapper>
      {examGradingQuestions?.map((question) => {
        return (
          <tr
            key={`exam-grading-question-${question.subject}-id-${question.seq}`}
          >
            <td className="cell-bold">
              {question.seq.toString().padStart(2, '0')}
            </td>
            <td className="cell-bold">
              {answerNumberMap[question.answers[0] - 1]}
            </td>
            <td
              className={`cell-bold ${
                question.answers[0] === question.userAnswers[0]
                  ? 'correct-answer'
                  : ''
              }`}
            >
              {answerNumberMap[question.userAnswers[0] - 1]}
            </td>
            <td>{question.statistics[0].rate}%</td>
            <td>{question.statistics[1].rate}%</td>
            <td>{question.statistics[2].rate}%</td>
            <td>{question.statistics[3].rate}%</td>
            <td>{question.statistics[4].rate}%</td>
          </tr>
        )
      })}
    </StyledWrapper>
  )
}

export default TentativeScoringTableBody

const StyledWrapper = styled.tbody`
  ${({ theme }) => css`
    & > tr {
      height: 52px;

      & > td {
        height: 52px;
        border: solid 1px #eeeeee;
        border-collapse: collapse;
        text-align: center;
        vertical-align: middle;
        font-weight: normal;
        font-size: 16px;
        line-height: 52px;
        letter-spacing: -0.64px;
        text-align: center;
        color: ${theme.color.text_1};

        &:last-child {
          border-right: 0;
        }

        &:first-child {
          border-left: 0;
        }

        &.correct-answer {
          color: #004eff;
        }

        &.cell-bold {
          font-weight: 500;
        }
      }
    }
  `}
`
